export enum RepetitionPeriod {
  Week = 1,
  Month = 2,
  Year = 3,
}
